import { Box, Text, Fade, Stack, useDisclosure } from "@chakra-ui/react";
import BaseLayout from "../../components/base_layout";
import MypageNavigation from "../../components/navi/mypageNavi";
import React, { useState, useEffect, useCallback } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useRouter } from "next/router";
import { getReferrer } from "../../provider/referrer";
import { GetCookie } from "../../provider/common";
import { getEstimateData } from "../api/estimate";
import stylesButton from "../../styles/index.module.css";
import Pagination from "react-js-pagination";
import Link from "next/link";

const axios = require("axios").default;
export default function EsimateRequest() {
  const router = useRouter();
  const [isLogin, setIsLogin] = useState(0);
  const [referrer, setReferrer] = useState("");
  useEffect(() => {
    checkLogin();
    setReferrer(getReferrer());
  }, []);

  console.log(isLogin);

  // 로그인 체크
  const checkLogin = async () => {
    const loginInfo = await GetCookie("isLogin");
    setIsLogin(loginInfo);
  };

  return (
    <BaseLayout>
      <Box id="quote">
        <Box>
          <Box>
            <Box>{/* <Link href="/estimate/home">견적요청</Link> */}</Box>
            <Box>
              {/* <Link href="/estimate/quote_lists">견적내역</Link> */}
            </Box>
          </Box>
        </Box>
        <Box className="quote_tit_area">
          <h1 className="quotes_title"></h1>
        </Box>
        <section className="quote_logos">
          <Box>
            <Box className="quote_logos_tp">
              <h3>판다봇 견적</h3>
              <strong>전자부품 견적의 새로운 기준을 경험하세요.</strong>
              <ul>
                <li>
                  <img src="../../images/brand/search/digikey_logo.png" />
                </li>
                <li className="logo_arrow">
                  <img src="../../images/brand/search/arrow_logo.png" />
                </li>

                <li>
                  <img src="../../images/logo/tti.png" />
                </li>
                <li className="logo_mouser">
                  <img src="../../images/brand/search/mouser_logo.svg.png" />
                </li>
                <li className="logo_element14">
                  <img src="../../images/brand/main/element14_logo.png" />
                </li>
                <li className="logo_onechip">
                  <img src="../../images/brand/search/onechip_logo.png" />
                </li>
                <li className="logo_verical">
                  <img src="../../images/brand/search/verical_logo.png" />
                </li>
                <li>
                  <img src="../../images/logo/future.png" />
                </li>
              </ul>
              <ul>
                <li className="logo_harting">
                  <img src="../../images/brand/main/harting_logo.svg.png" />
                </li>
                <li className="logo_apem">
                  <img src="../../images/logo/apem.png" />
                </li>
                <li className="logo_texasindustry">
                  <img src="../../images/logo/texasinstruments.png" />
                </li>
                <li className="logo_microchip">
                  <img src="../../images/logo/microchip.svg.png" />
                </li>
                <li className="logo_inferion">
                  <img src="../../images/logo/inferion.png" />
                </li>
                <li className="logo_minicircuits">
                  <img src="../../images/logo/minicircuits.png" />
                </li>
                <li className="logo_dfrobot">
                  <img src="../../images/brand/search/dfrobot_logo.png" />
                </li>

                <li>
                  <img src="../../images/logo/rochester.png" />
                </li>
              </ul>
            </Box>
            <Box className="quote_logos_btm">
              <Box>
                <p>
                  <em></em>글로벌 공인 유통사 20+곳 API 실시간 연동
                </p>
                <p>
                  <em></em>제조사 3,000+, 전자부품 1,600만+ 품목 지원
                </p>
                <p>
                  <em></em>자동화된 견적 시스템으로 클릭 한 번에 완료
                </p>
                <p>
                  <em></em>정품 인증을 위한 100% COC(Certificate of Compliance)
                  제공
                </p>
              </Box>
            </Box>
          </Box>
        </section>
        <Box className="quote_goto">
          {/* <p>견적유형을 선택해 주세요.</p> */}
          <Box>
            <Link href="/estimate/quote_request" passHref>
              <div
                className={`${stylesButton.buttonFillPrimary}`}
                style={{ cursor: "pointer" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={
                    typeof window !== "undefined" && window.innerWidth <= 601
                      ? "16"
                      : "24"
                  }
                  height={
                    typeof window !== "undefined" && window.innerWidth <= 601
                      ? "16"
                      : "24"
                  }
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M20.0484 11.7619L9.54838 23.0119C9.43711 23.1306 9.29023 23.21 9.12992 23.2379C8.9696 23.2659 8.80455 23.2409 8.65966 23.1668C8.51476 23.0928 8.3979 22.9736 8.3267 22.8272C8.2555 22.6809 8.23382 22.5154 8.26494 22.3556L9.63932 15.481L4.23651 13.4522C4.12047 13.4088 4.017 13.3373 3.93533 13.2442C3.85366 13.151 3.79633 13.0391 3.76847 12.9184C3.74062 12.7977 3.7431 12.6719 3.77569 12.5524C3.80828 12.4329 3.86998 12.3233 3.95526 12.2335L14.4553 0.983457C14.5665 0.86471 14.7134 0.785374 14.8737 0.757423C15.034 0.729473 15.1991 0.754423 15.344 0.828509C15.4889 0.902595 15.6057 1.0218 15.6769 1.16813C15.7481 1.31446 15.7698 1.47998 15.7387 1.63971L14.3606 8.52189L19.7634 10.5478C19.8786 10.5915 19.9812 10.6629 20.0622 10.7557C20.1433 10.8485 20.2002 10.9598 20.228 11.0798C20.2558 11.1998 20.2536 11.3248 20.2216 11.4438C20.1897 11.5628 20.1289 11.672 20.0446 11.7619H20.0484Z"
                    fill="white"
                  />
                </svg>
                <span
                  className={
                    typeof window !== "undefined" && window.innerWidth <= 601
                      ? `${stylesButton.white} body3`
                      : `${stylesButton.white} body1`
                  }
                >
                  판다봇 견적요청하기
                </span>
              </div>
            </Link>
            {/* <Link href="/estimate/quote_request_file" passHref>
              <a
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = "/estimate/quote_request_file";
                }}
              >
                BOM 견적요청
              </a>
            </Link> */}
          </Box>
        </Box>
      </Box>
    </BaseLayout>
  );
}
